// @generated by protoc-gen-es v1.4.2 with parameter "target=js+dts"
// @generated from file public_api/portfolio/v1/private_benchmark.proto (package public_api.portfolio.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message public_api.portfolio.v1.Benchmark
 */
export const Benchmark = proto3.makeMessageType(
  "public_api.portfolio.v1.Benchmark",
  () => [
    { no: 5, name: "fund_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "id" },
    { no: 6, name: "portfolio_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "id" },
    { no: 7, name: "composite_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "id" },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.GetPrivateFundBenchmarksRequest
 */
export const GetPrivateFundBenchmarksRequest = proto3.makeMessageType(
  "public_api.portfolio.v1.GetPrivateFundBenchmarksRequest",
  () => [
    { no: 1, name: "fund_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.GetPrivatePortfolioBenchmarksRequest
 */
export const GetPrivatePortfolioBenchmarksRequest = proto3.makeMessageType(
  "public_api.portfolio.v1.GetPrivatePortfolioBenchmarksRequest",
  () => [
    { no: 1, name: "portfolio_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.SetPrivateFundBenchmarksRequest
 */
export const SetPrivateFundBenchmarksRequest = proto3.makeMessageType(
  "public_api.portfolio.v1.SetPrivateFundBenchmarksRequest",
  () => [
    { no: 1, name: "fund_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "benchmarks", kind: "message", T: Benchmark, repeated: true },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.SetPrivatePortfolioBenchmarksRequest
 */
export const SetPrivatePortfolioBenchmarksRequest = proto3.makeMessageType(
  "public_api.portfolio.v1.SetPrivatePortfolioBenchmarksRequest",
  () => [
    { no: 1, name: "portfolio_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "benchmarks", kind: "message", T: Benchmark, repeated: true },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.GetPrivateFundBenchmarksResponse
 */
export const GetPrivateFundBenchmarksResponse = proto3.makeMessageType(
  "public_api.portfolio.v1.GetPrivateFundBenchmarksResponse",
  () => [
    { no: 1, name: "benchmarks", kind: "message", T: Benchmark, repeated: true },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.GetPrivatePortfolioBenchmarksResponse
 */
export const GetPrivatePortfolioBenchmarksResponse = proto3.makeMessageType(
  "public_api.portfolio.v1.GetPrivatePortfolioBenchmarksResponse",
  () => [
    { no: 1, name: "benchmarks", kind: "message", T: Benchmark, repeated: true },
  ],
);

/**
 * @generated from message public_api.portfolio.v1.SetPrivateFundBenchmarksResponse
 */
export const SetPrivateFundBenchmarksResponse = proto3.makeMessageType(
  "public_api.portfolio.v1.SetPrivateFundBenchmarksResponse",
  [],
);

/**
 * @generated from message public_api.portfolio.v1.SetPrivatePortfolioBenchmarksResponse
 */
export const SetPrivatePortfolioBenchmarksResponse = proto3.makeMessageType(
  "public_api.portfolio.v1.SetPrivatePortfolioBenchmarksResponse",
  [],
);

